module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[41]528.45dcca8.woff2";